$(document).ready ->
  $(document).on 'click', '#print_page', (e) ->
    e.preventDefault();
    window.print()
    return

  return
